class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');

      // Custom: Cart Remove Button
      // Added loading indicator when deleting cart item
      if(this.closest('cart-drawer-items')) {
        this.toggleLoadIcon(true);
      }

      cartItems.updateQuantity(this.dataset.index, 0, event);
    });
  }

  // Custom: Cart Remove Button
  // Toggle function for the show and hide of icon remove and icon loading for the cart remove button
  toggleLoadIcon(isLoading) {
    const svgIcons = this.querySelectorAll('svg');
    if (svgIcons.length >= 2) {
      // If loading is true, show loader and hide remove icon
      svgIcons[0].style.display = isLoading ? "none" : "block";   // Remove icon
      svgIcons[1].style.display = isLoading ? "block" : "none";   // Loader icon
    }
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));

    // Custom: Addon Sets
    // Enter would submit the cart form to checkout; blur so the change goes through updateQuantity instead
    this.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' || !event.target.classList.contains('quantity__input')) return;
      event.preventDefault();
      event.target.blur();
    });
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      return this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        event,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    //ensures that the else condition is always called. This fix the bug on cart recommendation for mobile not showing
    //the else condition just update the cart-drawer-items partially similar to dawn 10 implementation
    if (false && this.tagName === 'CART-DRAWER-ITEMS') {
      return fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      return fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  // Custom: Addon Sets
  // Moves a set parent and its addons together; every other line keeps Dawn's single /cart/change.js call
  async fetchCartMutation(line, quantity, body) {
    const setHelpers = window.AddonSetRelationships;

    // Only a parent row can cascade; removals still read the cart to catch a stale page
    const mayCascade = this.domRowUid(line) !== null || Number(quantity) === 0;

    if (setHelpers && mayCascade && this.querySelector('[data-lj-set]')) {
      try {
        // Raise straight from the rendered rows, skipping the cart read
        const fromDom = quantity > 0 ? this.domSet(line) : null;

        if (fromDom && quantity > fromDom.parent.quantity) {
          return await this.raiseSet(fromDom.parent, fromDom.children, quantity);
        }

        const cart = await setHelpers.fetchCart();
        const parent = cart.items[line - 1];
        const lineUid = parent ? setHelpers.getLineUid(parent) : null;

        // The cart changed under this page (another tab, an app): don't cascade onto the wrong set
        const stale = lineUid !== null && lineUid !== this.domRowUid(line);

        if (stale) {
          console.warn(
            '[addon-set] the cart changed under this page; not cascading on line',
            line
          );

          // Removing here would strand the addons, so refuse instead
          if (Number(quantity) === 0) {
            const staleError = new Error('cart changed under this page');
            staleError.ljNoFallthrough = true;
            throw staleError;
          }
        }

        const children = lineUid && !stale ? setHelpers.findChildren(cart, lineUid) : [];

        if (children.length > 0) {
          // Lowering can't exceed stock, so one /cart/update.js call
          if (quantity <= parent.quantity) {
            return this.markSetLevelled(await this.lowerSetTo(parent, children, quantity));
          }

          // Raising goes line by line through /cart/change.js, which checks stock
          return await this.raiseSet(parent, children, quantity);
        }
      } catch (error) {
        // Fall back to Dawn's single-line update, except when removing a parent (it would strand its addons)
        if (error.ljNoFallthrough || (Number(quantity) === 0 && this.domRowUid(line))) {
          console.warn('[addon-set] not removing a set parent without its addons', error);
          throw error;
        }

        console.warn('[addon-set] could not cascade to addons', error);
      }
    }

    return fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } });
  }

  // Custom: Addon Sets
  // Tells reconcile this set is already in line so it can skip its cart read
  markSetLevelled(response) {
    if (response) response.ljSetLevelled = true;
    return response;
  }

  // Custom: Addon Sets
  // Set rows of this surface shaped like cart items; quantities come from the rendered value attribute
  domSetLines() {
    const rows = this.querySelectorAll('[data-lj-line]');
    if (rows.length === 0) return null;

    const items = [];

    for (const row of rows) {
      const line = parseInt(row.dataset.ljLine, 10);
      const input = row.querySelector('.quantity__input');
      const quantity = input ? parseInt(input.getAttribute('value'), 10) : NaN;

      if (!Number.isFinite(line) || line < 1 || !Number.isFinite(quantity)) return null;

      const properties = {};
      if (row.dataset.ljUid) properties._lj_line_uid = row.dataset.ljUid;
      if (row.dataset.ljRel) properties._lj_relationship_1 = row.dataset.ljRel;

      items.push({ line, quantity, properties });
    }

    return { items };
  }

  // Custom: Addon Sets
  // The set uid stamped on the row at `line`, or null
  domRowUid(line) {
    const wanted = parseInt(line, 10);
    if (!Number.isFinite(wanted)) return null;

    const row = this.querySelector(`[data-lj-line="${wanted}"]`);
    return (row && row.dataset.ljUid) || null;
  }

  // Custom: Addon Sets
  // The set a line belongs to, resolved from the markup alone, or null
  domSet(line) {
    const setHelpers = window.AddonSetRelationships;
    const domCart = this.domSetLines();
    if (!domCart) return null;

    // `line` comes from a dataset as a string
    const wanted = parseInt(line, 10);
    const parent = domCart.items.find((item) => item.line === wanted);
    if (!parent) return null;

    const lineUid = setHelpers.getLineUid(parent);
    if (!lineUid) return null;

    const children = setHelpers.findChildren(domCart, lineUid);
    if (children.length === 0) return null;

    return { parent, children };
  }

  // Custom: Addon Sets
  // Sections half of a cart mutation body
  setSectionsBody() {
    return {
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    };
  }

  // Custom: Addon Sets
  // Lowers a whole set in one /cart/update.js call; lines are clamped so it never raises
  lowerSetTo(parent, children, quantity) {
    const setHelpers = window.AddonSetRelationships;
    const updates = { [parent.key]: Math.min(parent.quantity, quantity) };

    children.forEach((child) => {
      updates[child.key] = Math.min(child.quantity, quantity * setHelpers.getQtyRatio(child));
    });

    const setBody = JSON.stringify({ updates, ...this.setSectionsBody() });

    return fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body: setBody } });
  }

  // Custom: Addon Sets
  // Address a line by key when known, otherwise by its 1-based line as Dawn does
  lineTarget(item) {
    return item.key ? { id: item.key } : { line: item.line };
  }

  // Custom: Addon Sets
  // One /cart/change.js call; returns the cart (null if refused) and a re-readable response
  async changeSetLine(item, quantity, withSections) {
    const payload = { ...this.lineTarget(item), quantity };
    if (withSections) Object.assign(payload, this.setSectionsBody());

    const response = await fetch(`${routes.cart_change_url}`, {
      ...fetchConfig(),
      ...{ body: JSON.stringify(payload) },
    });

    const text = await response.text();
    let parsed = null;

    try {
      parsed = JSON.parse(text);
    } catch (error) {
      parsed = null;
    }

    return {
      cart: parsed && Array.isArray(parsed.items) ? parsed : null,
      response: new Response(text, {
        status: response.status,
        headers: { 'Content-Type': 'application/json' },
      }),
    };
  }

  // Custom: Addon Sets
  // Finds a set by uid; line keys can change mid-cascade, the uid does not
  resolveSet(cart, lineUid) {
    const setHelpers = window.AddonSetRelationships;
    if (!cart || !Array.isArray(cart.items)) return null;

    const parent = cart.items.find((item) => setHelpers.getLineUid(item) === lineUid);
    if (!parent) return null;

    return { parent, children: setHelpers.findChildren(cart, lineUid) };
  }

  // Custom: Addon Sets
  // Raises the addons first, then the parent to the lowest quantity every addon reached
  async raiseSet(parent, children, quantity) {
    const setHelpers = window.AddonSetRelationships;
    const lineUid = setHelpers.getLineUid(parent);
    const accepted = [];
    let anyRefused = false;

    let current = { parent, children };

    // Children first, so the parent is only raised as far as its addons can go
    for (let index = 0; index < children.length; index++) {
      const child = current.children[index];
      const result = await this.changeSetLine(
        child,
        quantity * setHelpers.getQtyRatio(child),
        false
      );

      const fresh = this.resolveSet(result.cart, lineUid);

      if (fresh && fresh.children.length === children.length) {
        current = fresh;
        accepted.push(fresh.children[index].quantity);
      } else {
        // Refused: re-read below, since a refused change can still move the line
        anyRefused = true;
        accepted.push(child.quantity);
      }
    }

    // A refused change can still move the line to the available stock, so re-read once
    if (anyRefused) {
      try {
        const refreshed = this.resolveSet(await setHelpers.fetchCart(), lineUid);

        if (refreshed && refreshed.children.length === children.length) {
          current = refreshed;
          refreshed.children.forEach((child, index) => {
            accepted[index] = child.quantity;
          });
        }
      } catch (error) {
        console.warn('[addon-set] could not re-read the cart after a refused child change', error);
      }
    }

    // Never lower than where the set already sits
    const cap = Math.max(
      current.parent.quantity,
      children.reduce(
        (lowest, child, index) =>
          Math.min(lowest, Math.floor(accepted[index] / setHelpers.getQtyRatio(child))),
        quantity
      )
    );

    // The parent goes last and carries the sections to render
    const parentResult = await this.changeSetLine(current.parent, cap, true);
    let afterParent = this.resolveSet(parentResult.cart, lineUid);

    // Parent change refused: re-read once for fresh keys
    if (!afterParent) {
      try {
        afterParent = this.resolveSet(await setHelpers.fetchCart(), lineUid);
      } catch (error) {
        console.warn('[addon-set] could not re-read the cart after the parent change', error);
      }
    }

    // Still can't see the set: leave it for reconcile (not marked as levelled)
    if (!afterParent) return parentResult.response;

    const settled = afterParent.parent.quantity;
    const strays = afterParent.children.filter(
      (child) => child.quantity > settled * setHelpers.getQtyRatio(child)
    );

    if (strays.length === 0) return this.markSetLevelled(parentResult.response);

    // An addon ended above the parent: lower it to match
    return this.markSetLevelled(
      await this.lowerSetTo(afterParent.parent, afterParent.children, settled)
    );
  }

  updateQuantity(line, quantity, event, name, variantId) {
    this.enableLoading(line);
  
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    const eventTarget = event.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';

    // Custom: Addon Sets
    // Carried on both cartUpdate publishes so reconcile can skip a set cart.js already levelled
    let setLevelled = false;

    this.fetchCartMutation(line, quantity, body)
      .then((response) => {
        // Custom: Cart Update Quantity
        // Moved the publish event for cart update
        // Custom: Addon Sets - also carries setLevelled
        setLevelled = response.ljSetLevelled === true;

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', setLevelled });
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        CartPerformance.measure(`${eventTarget}:paint-updated-sections"`, () => {     
          // Custom: Addon Sets
          // Look in this surface first: on the cart page the drawer has the same line ids
          const quantityElement =
            this.querySelector(`#Quantity-${line}, #Drawer-quantity-${line}`) ||
            document.getElementById(`Quantity-${line}`) ||
            document.getElementById(`Drawer-quantity-${line}`);
          // Custom: Addon Sets
          // Scoped to this surface, otherwise the drawer doubles the count on the cart page
          const items = this.querySelectorAll('.cart-item');
    
          if (parsedState.errors) {
            quantityElement.value = quantityElement.getAttribute('value');
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }
    
          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');
    
          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
    
          // Custom: Cart Update
          // handle simultaneous removal of cart item and rendering of cart recommendations
          if (quantity === 0) {
            // Set up an event listener for cartRecommendations
            // This will run once the recommendations are fully updated
            const waitForRecommendations = (event) => {
              // Now we can update the cart display with the parsed state
              this.getSectionsToRender().forEach((section) => {
                const elementToReplace =
                  document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                
                elementToReplace.innerHTML = this.getSectionInnerHTML(
                  parsedState.sections[section.section],
                  section.selector
                );
              });
              
              const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
              let message = '';
              if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
                if (typeof updatedValue === 'undefined') {
                  message = window.cartStrings.error;
                } else {
                  message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
                }
              }
              this.updateLiveRegions(line, message);
      
              const lineItem =
                document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
              if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
                cartDrawerWrapper
                  ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
                  : lineItem.querySelector(`[name="${name}"]`).focus();
              } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
                trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
              } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
                trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
              }
              
              // Remove this one-time listener
              document.removeEventListener('cart:recommendations-updated', waitForRecommendations);
            };
            
            // Add a one-time DOM event listener
            document.addEventListener('cart:recommendations-updated', waitForRecommendations, { once: true });
            
            // Find the cart-recommendations component and trigger a manual update
            const cartRecommendations = document.querySelector('cart-recommendations');
            if (cartRecommendations) {
              if (parsedState.item_count === 0) {
                // If this was the last item, hide recommendations immediately
                cartRecommendations.hideHeaders();
                cartRecommendations.clearContainers(
                  document.getElementById('container-recommended-products-desktop'),
                  document.getElementById('container-recommended-products-mobile')
                );
                // Immediately dispatch the event to continue with cart update
                document.dispatchEvent(new CustomEvent('cart:recommendations-updated'));
              } else {
                // Otherwise update recommendations normally
                cartRecommendations.handleCartUpdate();
              }
            } else {
              // If no cart-recommendations component is found, fall back to direct update
              this.getSectionsToRender().forEach((section) => {
                const elementToReplace =
                  document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                elementToReplace.innerHTML = this.getSectionInnerHTML(
                  parsedState.sections[section.section],
                  section.selector
                );
              });
            }
  
            //Signal to refresh the complementary products section 
            document.dispatchEvent(new CustomEvent('refresh:complementary-products'));
  
          } else {
            // For non-removal updates, proceed with regular cart update flow immediately
            this.getSectionsToRender().forEach((section) => {
              const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            });
            
            const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
            let message = '';
            if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
              if (typeof updatedValue === 'undefined') {
                message = window.cartStrings.error;
              } else {
                message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
              }
            }
            this.updateLiveRegions(line, message);
    
            const lineItem =
              document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
            if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
              cartDrawerWrapper
                ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
                : lineItem.querySelector(`[name="${name}"]`).focus();
            } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
              trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
            } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
              trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
            }
          }
        });

        CartPerformance.measureFromEvent(`${eventTarget}:user-action`, event);

        // Custom: Addon Sets
        // Also carries setLevelled
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-items',
          cartData: parsedState,
          variantId: variantId,
          setLevelled,
        });
        
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    // Custom: Addon Sets
    // Look in this surface first, as in updateQuantity
    const lineItemError =
      this.querySelector(`#Line-item-error-${line}, #CartDrawer-LineItemError-${line}`) ||
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
              .then(() => CartPerformance.measureFromEvent('note-update:user-action', event));
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}